const DEFAULT_INVALID_URL_MESSAGE =
  "올바른 링크 주소를 입력해주세요. (예: https://example.com)";

/**
 * 링크(URL) 유효성 검사. validateDateRange와 동일한 { isValid, message } 형태를 반환한다.
 *
 * - 선택 입력 가정: 비어 있으면 통과한다(필수 여부는 호출부에서 따로 막는다).
 * - 프로토콜(http/https)이 없으면 https:// 를 보충해 검사하므로
 *   "example.com" 같은 입력도 허용되며, normalized에 프로토콜이 포함된 값을 돌려준다.
 * - 호스트에 점(.)이 없으면(예: "abc") 유효하지 않은 것으로 본다.
 *
 * @returns {{ isValid: boolean, message: string, normalized: string }}
 */
export function validateUrl(value, options = {}) {
  const message = options.message || DEFAULT_INVALID_URL_MESSAGE;
  const trimmed = (value ?? "").trim();

  if (!trimmed) {
    return { isValid: true, message: "", normalized: "" };
  }

  const candidate = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;

  try {
    const url = new URL(candidate);
    if (!url.hostname.includes(".")) {
      return { isValid: false, message, normalized: "" };
    }
    return { isValid: true, message: "", normalized: url.href };
  } catch {
    return { isValid: false, message, normalized: "" };
  }
}

export { DEFAULT_INVALID_URL_MESSAGE };
